import { render, staticRenderFns } from "./UserSettingsChangePassword.vue?vue&type=template&id=7c9b62d6"
import script from "./UserSettingsChangePassword.vue?vue&type=script&lang=js"
export * from "./UserSettingsChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports